import _ from "lodash";
import searchLogo from "../assets/images/searchLogo.svg";
import ContractLinkComponent from "../components/ContractLink";
import { dtcStatusColors, status } from "./constants";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";
import { rateFormatter } from "./commonFunctions";

function is_number(char: any) {
    return !isNaN(parseInt(char));
}
var myValueFormatter = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return formatNumber.format(p.value);
  }
};
var myValueFormatter_d = (p: any) => {
  let is_n = is_number(p.value);

  if (is_n) {
    return formatNumber_d.format(Math.ceil(p.value));
  }
};
const formatNumber = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});
const formatNumber_d = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

var myValueFormatter_quantity = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return formatNumber_q.format(p.value);
  }
};

const formatNumber_q = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

const markFormatter = (p: any) => {
  let mark:any;
  if (p?.value && !isNaN(p?.value) && _.isString(p.value)) {
   return parseInt(p.value);
  }
  else if (_.isNumber(p?.value)) {
   return p?.value;
  }
  if(mark){
    return Math.trunc(mark);
  }
  return "";
}

export const ColumnContractBrowserBorrowDefs = [
  {
    headerName: "",
    field: "isSelect",
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    headerCheckboxSelection: true,
    showDisabledCheckboxes: true,
    checkboxSelection: true,
    editable: false,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    pinned: "left",
    lockPinned: true,
    cellClass: "lock-pinned",

    minWidth: 50,
    maxWidth: 70,
    suppressSizeToFit: false,
  },
  {
    headerName: "Acc Id",
    field: "account_id",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "1px solid #DFDFDF",
      };
    },
    minWidth: 70,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Contract Id",
    field: "contract_id",
    floatingFilter: false,
    editable: false,
    filter: "agTextColumnFilter",
    lockPinned: true,
    cellClass: "lock-pinned",
    pinned: "left",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    cellRenderer: ContractLinkComponent,
    minWidth: 93,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "B/L",
    field: "contract_type",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 60,
    maxWidth: 70,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Id",
    field: "cpty_id",
    filter: "agTextColumnFilter",
    floatingFilter: false,
    editable: false,
    pinned: "left",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Name",
    field: "cpty_name",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 170,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    editable: false,
    pinned: "left",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    width: 65,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    editable: false,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 85,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    // filterParams: {
    //   allowedCharPattern: "\\d\\-\\,",
    //   numberParser: (text: any) => {
    //     return parseFloat(text.replace(",", ""));
    //   },
    // },
  },
  {
    headerName: "Security Name",
    field: "secMaster_name",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 200,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Quantity",
    field: "quantity",
    type: "rightAligned",
    valueFormatter: myValueFormatter_quantity,
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === 'Pending' && params?.node?.data?.contract_type === 'B' && ((params?.node?.data?.isReturnUpdated) || (params?.node?.data?.comments?.includes('Requested Return')))) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        };
      } else if (params.node.data.quantity < 0) {
        return {
          display: "flex",
          alignItems: "center",
          border: "2px solid red",
          justifyContent: "flex-end",
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        }
      }
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Rate",
    field: "rate",
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === 'Pending' && (params?.node?.data?.comments?.includes('Requested Int. Change'))) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
          backgroundColor: status.sent,
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        }
      }
    },
    minWidth: 90,
    maxWidth: 100,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    valueFormatter: rateFormatter
  },
  {
    headerName: "Contract Price",
    field: "contractPrice",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    type: "rightAligned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueFormatter: myValueFormatter,
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === 'Pending' && (params?.node?.data?.comments?.includes('Requested Mark to Mkt'))) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
          backgroundColor: status.sent,
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        }
      }
    },
    minWidth: 120,
    maxWidth: 180,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Mark",
    field: "collMgn",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: markFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === 'Pending' && (params?.node?.data?.comments?.includes('Requested Contract Maintenance Request for Mark'))) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
          textTransform: 'capitalize',
          justifyContent: "flex-end",
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        }
      }
    },
    minWidth: 70,
    maxWidth: 100,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Value",
    field: "contract_value",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    type: "rightAligned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueFormatter: myValueFormatter,
    cellStyle: function (params: any) {
      if (params?.node?.data?.isMarkToMarkUpdated || _.includes(params?.node?.data?.highlightedFields, 'contract_value')) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
          backgroundColor: status.sent,
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        }
      }
    },
    minWidth: 120,
    maxWidth: 180,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Market Value",
    field: "market_value",
    floatingFilter: false,
    editable: false,
    hide: true,
    type: "rightAligned",
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueFormatter: myValueFormatter,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
      justifyContent: "flex-end",
    },
    minWidth: 160,
    maxWidth: 180,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Trade Date",
    field: "trade_date",
    floatingFilter: false,
    editable: false,
    // filter: 'agDateColumnFilter',
    //   filterParams: filterParams,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 92,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Settle Date",
    field: "settle_date",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 93,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Div",
    field: "div",
    floatingFilter: false,
    type: "rightAligned",
    editable: false,
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 80,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    valueFormatter: markFormatter,
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === 'Pending' && (params?.node?.data?.comments?.includes('Requested Contract Maintenance Request for Div'))) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
          textTransform: 'capitalize'
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
        }
      }
    },
  },
  {
    headerName: "P/C",
    field: "profit_center",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === 'Pending' && (params?.node?.data?.comments == 'Requested PC Adj')) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
          textTransform: 'capitalize'
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
        }
      }
    },
    minWidth: 55,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Term Date",
    field: "term_date",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === 'Pending' && (params?.node?.data?.comments?.includes('Requested Contract Maintenance Request for Term Date'))) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
        }
      }
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Trader",
    field: "trader",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 80,
    maxWidth: 230,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Daily Accruals",
    field: "daily_accrual",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    type: "rightAligned",
    valueFormatter: myValueFormatter_d,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
      justifyContent: "flex-end",
    },
    minWidth: 120,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Sod Quantity",
    field: "sod_quantity",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    type: "rightAligned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueFormatter: myValueFormatter_quantity,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
      justifyContent: "flex-end",
    },
    minWidth: 120,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "IsBuyIn",
    field: "is_buyin",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "1px solid #DFDFDF",
      }
    },
    minWidth: 70,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Recall",
    field: "recall",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === 'Pending' && params?.node?.data?.contract_type === 'L' && ((params?.node?.data?.isRecallUpdated) || (params?.node?.data?.comments?.includes('Requested Recall')))) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
          borderRight: "1px solid #DFDFDF",
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
        }
      }
    },
    minWidth: 50,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Recall Date",
    field: "recall_date",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === 'Pending' && params?.node?.data?.contract_type === 'L' && ((params?.node?.data?.isRecallUpdated) || (params?.node?.data?.comments?.includes('Requested Recall')))) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
          borderRight: "1px solid #DFDFDF",
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
        }
      }
    },
    minWidth: 95,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Exp Date",
    field: "recall_expiry_date",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === 'Pending' && params?.node?.data?.contract_type === 'L' && ((params?.node?.data?.isRecallUpdated) || (params?.node?.data?.comments?.includes('Requested Recall')))) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
          borderRight: "1px solid #DFDFDF",
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
        }
      }
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },

  {
    headerName: "C/N",
    field: "cash_non_cash",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 60,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Collatoral Code",
    field: "collatoral_code",
    floatingFilter: false,
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },



  {
    headerName: "External Contract Id",
    field: "external_contract_id",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
      justifyContent: "flex-end",
    },
    minWidth: 200,
    maxWidth: 230,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  
  {
    headerName: "Updated Date",
    field: "updatedDateStr",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 160,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Updated By",
    field: "updated_by",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 100,
    maxWidth: 250,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
  },
  {
    headerName: "Lnet O/C",
    field: "status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    pinned: "right",
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 70,
    maxWidth: 150,
    cellStyle: function (params: any) {
      if (params.node.data.status === "Booked") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#039100",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else if (params.node.data.status === "Error") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#E90909",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
      else if (params.node.data.status === "Pending") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#0D34FF",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
      else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },
  {
    headerName: "Lnet Status",
    field: "processing_status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    pinned: "right",
    icons: {
      menu: `<img src="${searchLogo}" />`,

    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 100,
    maxWidth: 150,
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === "Error") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#E90909",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
      else if (params?.node?.data?.processing_status === "Pending") {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
        };
      }
       else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },
  {
    headerName: "DTC Status",
    field: "dtc_status",
    floatingFilter: false,
    editable: false,
    pinned: "right",
    filter: "agSetColumnFilter",
    lockPinned: true,
    cellClass: "lock-pinned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params.node.data.status === "Booked") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#039100",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else if (params.node.data.status === "Error") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#E90909",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else if (params.node.data.status === "Pending") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#0D34FF",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "settled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.settled
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "rad") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.RAD
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "approved") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.approved
        };
      }
      else if (params?.data?.dtc_status?.toLowerCase() === "pended") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.pended
        };

      } else if (params?.data?.dtc_status?.toLowerCase() === "reversed") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.reversed
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "dropped") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.dropped
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "non-ccf") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.nonCcf
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "canceled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.canceled
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
 
  {
    headerName: "Comments",
    field: "comments",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    pinned: "right",
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    tooltipField: "comments",
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 100,
    maxWidth: 600,
    tooltipComponentParams: function(params: any){
      return {
        message: params?.node?.data?.comments,
      }; 
    },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    resizable: true
  },
];